import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { StyledSidemenuItem } from "../../styles/StyledSidemenu";
import AddIcon from "../../assets/img/icons/add.svg";
import useCurrentUser from "../../hooks/useCurrentUser";

// The add (+) link next to a menu item, for users with its permission
const addPaths = [
	{ when: "/decisions", path: "/add-decision", permission: "createDecisions" },
	{ when: "/units", path: "/add-unit", permission: "createUnits" },
	{ when: "/meetings", path: "/add-meeting", permission: "unitWork" },
];

export default function SidemenuItem({ item }) {
	const location = useLocation();
	const { can } = useCurrentUser();
	const add = addPaths.find((add) => add.when === item.path);

	if (add && can(add.permission)) {
		return (
			<StyledSidemenuItem
				active={location.pathname === item.path ? true : false}
				data-testid={location.pathname === item.path ? "active" : undefined}
			>
				<Link to={item.path}>{item.name}</Link>
				<Link to={add.path}>
					<img src={AddIcon} alt="Add" />
				</Link>
			</StyledSidemenuItem>
		);
	}
	return (
		<StyledSidemenuItem
			active={location.pathname === item.path ? true : false}
			data-testid={location.pathname === item.path ? "active" : undefined}
		>
			<Link to={item.path}>{item.name}</Link>
		</StyledSidemenuItem>
	);
}

SidemenuItem.propTypes = {
	item: PropTypes.object,
};
